(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orzo-event-planner"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('#OrzoEventContact').forEach(form => {
  const date = form.querySelector('[data-event-date]');
  if (date) { const today = new Date(); date.min = [today.getFullYear(), String(today.getMonth()+1).padStart(2,'0'), String(today.getDate()).padStart(2,'0')].join('-'); }
  const venue = form.querySelector('[data-event-venue]');
  const venueMail = form.querySelector('[data-event-venue-mail]');
  const syncMail = () => { if (!venue || !venueMail) return; const o = venue.selectedOptions[0]; venueMail.value = (o && o.dataset.mail) || ''; };
  try { const selected = localStorage.getItem('orzo.preferredVenue'); const option = venue && [...venue.options].find(x => x.dataset.handle === selected); if (option) venue.value = option.value; } catch (_) {}
  const params = new URLSearchParams(location.search);
  const type = form.querySelector('[data-event-type]');
  const wantedType = params.get('typ');
  if (type && wantedType) { const w = wantedType.toLowerCase(); const opt = [...type.options].find(x => x.value.toLowerCase() === w || x.text.toLowerCase() === w) || [...type.options].find(x => x.value && x.text.toLowerCase().startsWith(w)); if (opt) type.value = opt.value || opt.text; }
  const guests = form.querySelector('input[name="contact[Liczba gości]"]');
  if (guests && params.get('osoby')) guests.value = params.get('osoby');
  const wantedHall = params.get('sala');
  let halls = {};
  if (wantedHall) { try { halls = JSON.parse((document.querySelector('[data-event-sale]') || {}).textContent || '{}'); } catch (_) { halls = {}; } }
  const hall = wantedHall && halls[wantedHall];
  const wantedVenue = params.get('lokal') || (hall && hall.l) || null;
  if (venue && wantedVenue) { const opt = [...venue.options].find(x => x.dataset.handle === wantedVenue); if (opt) venue.value = opt.value; }
  const wantedCity = params.get('miasto');
  if (venue && wantedCity && !wantedVenue) { const opt = [...venue.options].find(x => x.value.toLowerCase().includes(wantedCity.toLowerCase())); if (opt) venue.value = opt.value; }
  const wantedPack = params.get('pakiet');
  const notes = form.querySelector('[data-event-notes]');
  if (notes && !notes.value) {
    const lines = [];
    if (hall && hall.n) lines.push((notes.dataset.salaPrefix || 'Sala') + ': ' + hall.n);
    if (wantedPack) {
      let names = {};
      try { names = JSON.parse((document.querySelector('[data-event-pakiety]') || {}).textContent || '{}'); } catch (_) { names = {}; }
      if (names[wantedPack]) lines.push((notes.dataset.pakietPrefix || 'Menu') + ': ' + names[wantedPack]);
    }
    if (lines.length) notes.value = lines.join('\n');
  }
  const msgs = form.querySelector('[data-pe-msgs]');
  if (msgs) {
    form.noValidate = true;
    const t = msgs.dataset;
    const fields = [...form.querySelectorAll('[required][data-err]')];
    const why = el => {
      const v = el.validity;
      if (v.valid) return '';
      if (el.type === 'checkbox') return t.errConsent;
      if (el.type === 'email' && !v.valueMissing) return t.errEmail;
      if (el.type === 'date' && !v.valueMissing) return t.errDate;
      if (el.type === 'number') return t.errGuests;
      return t.errReq;
    };
    const check = el => {
      const box = document.getElementById(el.dataset.err);
      const m = why(el);
      if (box) { box.textContent = m; box.hidden = !m; }
      if (m) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
      return !m;
    };
    fields.forEach(el => {
      const again = () => { if (el.hasAttribute('aria-invalid')) check(el); };
      el.addEventListener('input', again);
      el.addEventListener('change', again);
    });
    form.addEventListener('submit', e => {
      let first = null;
      fields.forEach(el => { if (!check(el) && !first) first = el; });
      if (first) { e.preventDefault(); e.stopImmediatePropagation(); first.focus(); }
    });
  }
  if (venue) venue.addEventListener('change', syncMail);
  form.addEventListener('submit', syncMail);
  syncMail();
  if ((params.get('osoby') || wantedType || wantedCity || wantedVenue || wantedPack || wantedHall) && !location.hash) form.scrollIntoView({ block: 'start' });
});
  } catch(e) { console.error(e); }
})();

})();
